import { render, staticRenderFns } from "./datatable-import-detail.vue?vue&type=template&id=9d4b0cb2&scoped=true"
import script from "./datatable-import-detail.vue?vue&type=script&lang=js"
export * from "./datatable-import-detail.vue?vue&type=script&lang=js"
import style0 from "./datatable-import-detail.vue?vue&type=style&index=0&id=9d4b0cb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d4b0cb2",
  null
  
)

export default component.exports